<template>
  <v-card class="mt-n7" elevation="0">
    <!-- <v-card elevation="2" class="my-4 mx-4"> -->
      <!-- ARCHIVAR TOCA -->
      <div v-if="cuenta && cuenta.status==44 && cuenta.ponencia_id == currentUser.ponencia.id && !archivar_toca">
        <v-alert
          outlined
          prominent
          type="error"
        >
          <div class="text-h6">
            El Toca No Puede darse de Baja
          </div>
          <div>
          <ul class="list">
            <li>Faltan firmas o no se ha generado la evidencia.</li>
          </ul>
          </div>
        </v-alert>
        <br>
      </div>
      <v-form v-if="cuenta && cuenta.status==44 && cuenta.ponencia_id == currentUser.ponencia.id && archivar_toca" ref="form" v-model="valid" lazy-validation>
        <div v-if="(cuenta && cuenta.status >=44)">
          <!-- <v-toolbar dense dark color="indigo lighten-1">
            <v-toolbar-title class="text-uppercase">Para archivar el Toca ingrese las fechas</v-toolbar-title>
          </v-toolbar> -->
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <div class="mt-5" v-if="role != 'secacu' && (cuenta && cuenta.status >= 43)">
                  <div>
                    <p class=" font-weight-bold text-15" style="color:#1D2E4B">
                     Para archivar el toca ingrese las fechas
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>  
          </v-card-text>
          <v-divider></v-divider>
          <v-card class="mt-3">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" class="mb-n3">
                  <v-menu
                    v-model="menu_fecha_sentencia"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fecha_sentencia"
                        label="Fecha Sentencia"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        dense
                        persistent-hint
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fecha_sentencia"
                      @input="menu_fecha_sentencia= false"
                      locale="es-mx"
                      outlined
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" class="mb-n3">
                  <v-menu
                    v-model="menu_fecha_baja"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fecha_baja"
                        label="Fecha Baja"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        dense
                        persistent-hint
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fecha_baja"
                      @input="menu_fecha_baja= false"
                      locale="es-mx"
                      outlined
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row align="center" justify="space-around">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    dense
                    class="white--text"
                    color="#1D2E4B"
                    :disabled="!valid"
                    @click="validate()"
                  >
                  <v-icon left>
                    mdi-archive-plus-outline
                  </v-icon>
                  Archivar toca
                  </v-btn>
                </v-card-actions>
              </v-row>
              
            </v-container>
          </v-card>
        </div>
      </v-form>
    <!-- </v-card> -->

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Sentido from "@/components/Sentido";
  export default {
    // components: {
    //   Sentido
    // },
    props: {
      apelacion: {
        type: Object,
        required: true
      },
      cuenta: {
        type: Object,
        required: true
      },
      role: {
        type: String,
        required: true
      }
    },
    data: () => ({
      active_tab: {},
      valid: false,
      // loading: false,
      menu_fecha_sentencia: false,
      menu_fecha_baja: false,
      fecha_sentencia: '',
      fecha_baja: '',
      archivar_toca: false,
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      },
      // voto_concurrente: false,
      // voto_particular: false,
      // mag_voto_particular: '',
      // mag_voto_concurrente: '',
      // obs_voto_particular:'',
      // obs_voto_concurrente:'',
    }),
    computed: {
      ...mapGetters([ "currentUser", "getAllPonencias" ])
    },
    mounted(){
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.active_tab = this.$route.params
      if (this.cuenta) {
        this.resultado = this.apelacion.documentos.find( doc =>
          doc.categoria_id === 3 && doc.url_evidencia != null
        );
        if (this.resultado) {
          this.archivar_toca = true
        }
      }
    },
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          this.save();
        }
      },
      save(){
        this.$store.dispatch("UPDATE_CUENTA", { url: "/cuenta/" + this.cuenta.id + '/archivar',
          data:{
            fecha_sentencia: this.fecha_sentencia,
            fecha_baja: this.fecha_baja
          }
        }).then(response => {
          if (response.status == 200) {
            this.$swal({
              title: "Éxito",
              text: "Toca archivada correctamente!!!",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.$emit('closeModal');
          }
        })
        .catch(error => {
          this.$emit('closeModal');
          console.log(error);
        });
      },
    }
  };
</script>